<template>
  <div :class="$style.wrap">
    <div :class="$style.content">
      <div :class="$style.bodyLayout">
        <ArticlePeak
          v-if="tableOfContentsMode !== 'off'"
          :class="$style.peak"
          :table-of-contents="tableOfContents"
          :target-selector="articleTargetSelector"
        />
        <div
          :class="$style.articleContent"
          :data-entry-title="computedEntryTitle || undefined"
          :data-long-form-editorial-id="props.data.sys.id"
        >
          <ArticleBody :data="computedArticleBody" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { TypeLongFormEditorialWithoutUnresolvableLinksResponse } from '~/types/contentful'

const props = defineProps<{
  data: TypeLongFormEditorialWithoutUnresolvableLinksResponse
}>()

interface TableOfContentsConfig {
  mode?: 'off' | 'auto' | 'custom'
  customHtml?: string
}

const computedArticleBody = computed(() => {
  const typedMarkdownEditorReturn = props.data?.fields?.content as {
    body: string
  }
  return typedMarkdownEditorReturn.body || ''
})

const computedEntryTitle = computed(() => {
  return props.data?.fields?.entryTitle
})

const tableOfContents = computed<TableOfContentsConfig | undefined>(
  () => props.data?.fields?.tableOfContents as TableOfContentsConfig,
)
const tableOfContentsMode = computed(() => tableOfContents.value?.mode ?? 'off')
const articleTargetSelector = computed(
  () => `[data-long-form-editorial-id="${props.data.sys.id}"]`,
)
</script>

<style lang="scss" module>
.wrap {
  background-color: var(--white);
  padding: 45px 20px 50px;
}

.content {
  max-width: 1350px;
  margin: 0 auto;
}

.bodyLayout {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2rem;

  @include media('lg') {
    flex-direction: row;
    gap: 3%;
  }
}

.peak {
  @include media('lg') {
    flex: 0 0 340px;
  }
}

.articleContent {
  width: 100%;
  min-width: 0;
}
</style>
